import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { pb } from '@/core/api';
import { useAuthStore } from '@/stores/auth';
import { invalidateAccessCache } from '@/core/access-check';
import { useToast } from '@/components/ui/toast';

// Fase 28 (28.6.2): "Salir del juego" — the forfeit path. Backend transitions
// to banned but does NOT flip has_used_redemption (per the locked decision:
// only successful redemption counts as "used"). Confirmation is enforced at
// the call site via the forfeit modal.
export function useForfeitRedemption() {
  const nav = useNavigate();
  const { toast } = useToast();
  const refreshAuth = useAuthStore((s) => s.refreshAuth);
  return useMutation({
    mutationFn: () =>
      pb.send('/api/team-members/redemption/forfeit', { method: 'POST' }),
    onSuccess: async () => {
      invalidateAccessCache();
      await refreshAuth();
      nav('/banned', { replace: true });
    },
    onError: () => toast('No se pudo cancelar la redención', 'error'),
  });
}
